import { __assign, __rest } from "tslib";
import ScriptNext from 'next/script';
import React from 'react';
function isBotUA() {
    if (typeof window === 'undefined' ||
        typeof window.navigator === 'undefined' ||
        typeof window.navigator.userAgent !== 'string') {
        return false;
    }
    return /bot|googlebot|crawler|spider|robot|crawling/i.test(window.navigator.userAgent);
}
var Script = function (props) {
    var id = props.id, _a = props.strategy, strategy = _a === void 0 ? 'afterInteractive' : _a, src = props.src, htmlContent = props.htmlContent, _data = props.data, _manifest = props.manifest, _b = props.type, scriptType = _b === void 0 ? 'text/javascript' : _b, rest = __rest(props, ["id", "strategy", "src", "htmlContent", "data", "manifest", "type"]);
    // Prevent worker/partytown scripts for bots/crawlers
    if (strategy === 'worker' && isBotUA()) {
        return null;
    }
    var scriptTypeStrategy = strategy === 'worker' ? 'text/partytown' : scriptType;
    var nextStrategy = strategy === 'worker' ? undefined : strategy;
    return (React.createElement(ScriptNext, __assign({}, rest, { id: id, src: src, type: scriptTypeStrategy, strategy: nextStrategy, dangerouslySetInnerHTML: htmlContent ? { __html: htmlContent } : undefined })));
};
export default Script;
//# sourceMappingURL=Script.js.map